import React, { useState, useCallback, useEffect } from 'react';
import { Stack } from '@mui/material';
import { Company } from '../../../../interfaces/users.interface';
import NewApplication from '../ApplicationModals/NewApplication';
import InhouseApplicationsCards from './InhouseApplications/InhouseApplicationsCards';
import LicensedApplicationsCards from './LicensedApplications/LicensedApplicationsCards';
import { TabSearchField } from '../../../Vendors/companyTabUi';

export const CompanyApplicationsTab = (props: {
  company: Company;
  userCanAdminCompany: boolean;
  companyCallback: any;
  addApplicationOpen?: boolean;
  onAddApplicationClose?: () => void;
}) => {
  const { company, companyCallback, userCanAdminCompany, addApplicationOpen: externalAddApplicationOpen, onAddApplicationClose } = props;

  const [internalAddApplicationOpen, setInternalAddApplicationOpen] = useState(false);
  // Bumped when the tab-level "Add Application" modal succeeds, so the
  // self-paginating card sections re-fetch their current page.
  const [reloadToken, setReloadToken] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');

  // Debounce typing into the server-side ?search= (application name) feeding both groups.
  useEffect(() => {
    const timeout = setTimeout(() => setSearch(searchInput.trim()), 300);
    return () => clearTimeout(timeout);
  }, [searchInput]);

  const addApplicationOpen = externalAddApplicationOpen !== undefined ? externalAddApplicationOpen : internalAddApplicationOpen;

  const handleAddApplicationClose = useCallback(() => {
    if (onAddApplicationClose) {
      onAddApplicationClose();
    } else {
      setInternalAddApplicationOpen(false);
    }
  }, [onAddApplicationClose]);

  const handleApplicationsChange = useCallback(
    (updatedCompany: Company) => {
      companyCallback(updatedCompany);
      setReloadToken((token) => token + 1);
    },
    [companyCallback],
  );

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      {/* The add modal's site/service selectors fetch their own options
          (searchable, server-paginated), so no full company object is needed. */}
      <NewApplication
        isOpen={addApplicationOpen}
        company={company}
        callBack={(co: Company) => {
          handleApplicationsChange(co);
          handleAddApplicationClose();
        }}
        handleClose={handleAddApplicationClose}
      />


      <TabSearchField value={searchInput} onChange={setSearchInput} placeholder='Search applications' />

      <InhouseApplicationsCards
        company={company}
        userCanAdminCompany={userCanAdminCompany}
        companyCallback={handleApplicationsChange}
        reloadToken={reloadToken}
        search={search}
      />

      <LicensedApplicationsCards
        company={company}
        userCanAdminCompany={userCanAdminCompany}
        companyCallback={handleApplicationsChange}
        reloadToken={reloadToken}
        search={search}
      />
    </Stack>
  );
};

export default CompanyApplicationsTab;
